import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m5.263 5 .455-1.472A1.458 1.458 0 0 1 7.11 2.5h5.778c.64 0 1.205.417 1.394 1.028L14.738 5h1.304a2.292 2.292 0 0 1 2.291 2.292v8.333a2.292 2.292 0 0 1-2.291 2.292H3.958a2.292 2.292 0 0 1-2.291-2.292V7.292A2.292 2.292 0 0 1 3.958 5h1.304Zm.46 1.25H3.959a1.042 1.042 0 0 0-1.041 1.042v8.333a1.042 1.042 0 0 0 1.041 1.042h12.084a1.042 1.042 0 0 0 1.041-1.042V7.292a1.042 1.042 0 0 0-1.041-1.042h-1.766a.625.625 0 0 1-.597-.44l-.59-1.913a.208.208 0 0 0-.2-.147H7.111a.208.208 0 0 0-.2.147l-.59 1.912a.625.625 0 0 1-.597.441ZM10 14.167a3.125 3.125 0 1 1 0-6.25 3.125 3.125 0 0 1 0 6.25Zm0-1.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z",
  "fill-rule": "nonzero",
  "data-follow-fill": "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }